var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMailConfirm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 440,
    height: 249,
    viewBox: "0 0 440 249",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M219.907 226.016C341.358 226.016 439.813 202.406 439.813 173.281C439.813 144.157 341.358 120.547 219.907 120.547C98.4555 120.547 0 144.157 0 173.281C0 202.406 98.4555 226.016 219.907 226.016Z",
    fill: "url(#paint0_radial_9550_78088)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M290.297 198.293H149.52C145.539 198.293 142.312 195.066 142.312 191.086V92.8026C142.312 90.097 143.614 87.5566 145.811 85.9766L214.998 36.2055C217.932 34.0952 221.885 34.0952 224.819 36.2055L294.006 85.9766C296.203 87.5566 297.505 90.097 297.505 92.8026V191.086C297.505 195.066 294.278 198.293 290.297 198.293H290.297Z",
    fill: "#DDE3E6",
    stroke: "#DDE3E6",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M231.1 136.619C230.074 137.362 229.291 137.084 228.721 138.098L225.668 135.479C222.354 132.637 217.463 132.637 214.149 135.479L211.096 138.098C210.526 137.084 209.743 137.362 208.717 136.619L142.312 93.3005L142.313 191.088C142.313 195.068 145.54 198.295 149.52 198.295H290.297C294.277 198.295 297.504 195.068 297.504 191.088L297.504 93.3005L231.1 136.619Z",
    fill: "white",
    stroke: "#DDE3E6",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M142.312 93.2986L211.435 139.007",
    stroke: "#DDE3E6",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M297.505 93.2986L228.383 139.007",
    stroke: "#DDE3E6",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M142.312 191.085L213.84 136.379C217.422 133.639 222.395 133.639 225.976 136.379L297.504 191.085",
    stroke: "#DDE3E6",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M221.745 0.827881C192.584 0.827881 168.945 24.4669 168.945 53.6274C168.945 82.7878 192.584 106.427 221.745 106.427C250.905 106.427 274.544 82.7877 274.544 53.6274C274.544 24.467 250.905 0.827881 221.745 0.827881Z",
    fill: "#6AD400"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M216.681 78.1914C215.759 78.1914 214.837 77.8394 214.133 77.1356L194.939 57.9413C193.531 56.5347 193.531 54.2519 194.939 52.8453C196.346 51.4376 198.627 51.4376 200.035 52.8453L216.681 69.4916L248.19 37.9833C249.598 36.5756 251.879 36.5756 253.286 37.9833C254.694 39.391 254.694 41.6727 253.286 43.0792L219.229 77.1356C218.525 77.8394 217.603 78.1914 216.681 78.1914Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "lighten"
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M275.782 53.6287C275.782 83.4687 251.592 107.659 221.752 107.659C191.912 107.659 167.721 83.4687 167.721 53.6287M293.149 53.629C293.149 93.0617 261.183 125.028 221.75 125.028C182.317 125.028 150.351 93.0617 150.351 53.629M309.956 53.6317C309.956 102.344 270.467 141.833 221.755 141.833C173.042 141.833 133.553 102.344 133.553 53.6317M327.06 53.6317C327.06 111.792 279.911 158.941 221.751 158.941C163.59 158.941 116.442 111.792 116.442 53.6317M345.093 53.6333C345.093 121.748 289.875 176.967 221.76 176.967C153.645 176.967 98.4268 121.748 98.4268 53.6333M363.097 53.6318C363.097 131.695 299.814 194.978 221.751 194.978C143.687 194.978 80.4042 131.695 80.4042 53.6318M381.693 53.6316C381.693 141.963 310.086 213.57 221.754 213.57C133.423 213.57 61.8162 141.963 61.8162 53.6316M398.605 53.6302C398.605 151.299 319.429 230.475 221.761 230.475C124.092 230.475 44.9166 151.299 44.9166 53.6302M415.76 53.63C415.76 160.774 328.903 247.631 221.759 247.631C114.615 247.631 27.7578 160.774 27.7578 53.63",
    stroke: "#F8F9F9",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_9550_78088",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(219.907 173.281) scale(204.622 46.5494)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDE3E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDE3E6",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailConfirm);
export default __webpack_public_path__ + "static/media/mail_confirm.9dd08a025eac9c0ed8277fc40ba28809.svg";
export { ForwardRef as ReactComponent };